import * as React from 'react';

export const TopIcon = () => {
  return (
    <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.5 20c0 9.665-7.835 17.5-17.5 17.5S2.5 29.665 2.5 20 10.335 2.5 20 2.5 37.5 10.335 37.5 20Zm-7.9284 1.0829c.1678.1943.0297.496-.2271.496H24V30h-8v-8.4211h-5.3445c-.2568 0-.3949-.3017-.2271-.496L20 10l9.5716 11.0829Z"
        fill="#152242"
        fillOpacity=".9"
      />
    </svg>
  );
};
